module.exports = __webpack_public_path__ + "img/pdf-file.01ef28ea.svg";